'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseStyleParams = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _fullscreen = require('@wix/photography-client-lib/dist/src/versioning/features/fullscreen');

var _baseUtils = require('@wix/photography-client-lib/dist/src/utils/baseUtils');

var _consts = require('@wix/photography-client-lib/dist/src/utils/consts');

var _consts2 = _interopRequireDefault(_consts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseStyleParams = exports.parseStyleParams = function parseStyleParams(styles) {

  var flatStyles = styles && (styles.numbers || styles.colors || styles.booleans || styles.fonts) ? (0, _extends3.default)({}, styles.numbers, styles.colors, styles.booleans, styles.fonts) : styles;

  var styleParams = {
    allowDownload: false,
    allowSocial: true,
    openStraightInFullscreen: false,
    loveButton: true,
    loveCounter: true,
    allowTitle: true,
    allowTitleExpand: true,
    allowDescriptionExpand: true,
    allowLinkExpand: true,
    allowFullscreenExpand: true,
    allowExifExpand: false,
    defaultShowInfoExpand: true,
    showInfoExpandButton: true,
    expandInfoPosition: 'SIDE',
    addToCartButtonText: '',
    galleryAlignExpand: 'left',
    fullscreenLoop: false,
    mobileSwipeAnimation: _consts2.default.mobileSwipeAnimations.EXPAND
  };

  if (_baseUtils.baseUtils.isMobile()) {
    flatStyles = convertToMobileSettingIfNeeded(flatStyles);
  }
  _lodash2.default.merge(styleParams, _lodash2.default.pick(flatStyles, ['actionsColorExpand', 'addToCartColorExpand', 'addToCartBackColorExpand', 'addToCartBorderColor', 'addToCartFontExpand', 'addToCartBorderWidth', 'bgColorExpand', 'titleColorExpand', 'descriptionColorExpand', 'titleFontExpand', 'descriptionFontExpand', 'allowDownload', 'allowSocial', 'loveButton', 'allowTitle', 'allowTitleExpand', 'allowDescriptionExpand', 'allowExifExpand', 'allowLinkExpand', 'allowFullscreenExpend', 'addToCartButtonText', 'fullscreenLoop', 'expandInfoPosition']));

  if (!_lodash2.default.isUndefined(flatStyles.expandInfoPosition)) {
    styleParams.expandInfoPosition = flatStyles.expandInfoPosition ? 'BOTTOM' : 'SIDE';
  }

  if (!_lodash2.default.isUndefined(flatStyles.loveCounter)) {
    styleParams.loveCounter = flatStyles.loveCounter === 0;
  }

  if (!_lodash2.default.isUndefined(flatStyles.galleryAlignExpand)) {
    switch (flatStyles.galleryAlignExpand) {
      case 0:
      default:
        styleParams.galleryAlignExpand = 'left';
        styleParams.galleryAlignExpandIcons = {
          float: 'left'
        };
        break;
      case 1:
        styleParams.galleryAlignExpand = 'center';
        styleParams.galleryAlignExpandIcons = {
          margin: 'auto'
        };
        break;
      case 2:
        styleParams.galleryAlignExpand = 'right';
        styleParams.galleryAlignExpandIcons = {
          float: 'right'
        };
        break;
    }
  }

  if (!_lodash2.default.isUndefined(flatStyles.videoSpeed)) {
    styleParams.videoSpeed = flatStyles.videoSpeed;
  }

  if (!_lodash2.default.isUndefined(flatStyles.videoLoop)) {
    styleParams.videoLoop = flatStyles.videoLoop;
  }

  if (!_lodash2.default.isUndefined(flatStyles.mobileSwipeAnimation)) {
    if (String(flatStyles.mobileSwipeAnimation) === '1') {
      styleParams.mobileSwipeAnimation = _consts2.default.mobileSwipeAnimations.FADE;
    } else if (String(flatStyles.mobileSwipeAnimation) === '2') {
      styleParams.mobileSwipeAnimation = _consts2.default.mobileSwipeAnimations.CAROUSEL;
    } else {
      //String(flatStyles.mobileSwipeAnimation) === '0'
      styleParams.mobileSwipeAnimation = _consts2.default.mobileSwipeAnimations.EXPAND;
    }
  }

  if (!_baseUtils.baseUtils.isMobile()) {
    if (!_lodash2.default.isUndefined(flatStyles.defaultShowInfoExpand)) {
      styleParams.defaultShowInfoExpand = flatStyles.defaultShowInfoExpand === 1 || flatStyles.expandInfoPosition;
      styleParams.showInfoExpandButton = _fullscreen.fullscreenVersionManager.useFullScreenMoreinfoButtonAlways() ? flatStyles.defaultShowInfoExpand !== 2 : flatStyles.defaultShowInfoExpand === 0 && !flatStyles.expandInfoPosition;
    } else {
      styleParams.showInfoExpandButton = _fullscreen.fullscreenVersionManager.useFullScreenMoreinfoButtonAlways();
    }
  } else {
    styleParams.defaultShowInfoExpand = false;
  }

  if (!_lodash2.default.isUndefined(flatStyles.addToCartButtonText)) {
    styleParams.addToCartButtonText = String(flatStyles.addToCartButtonText);
  }

  if (!_lodash2.default.isUndefined(flatStyles.allowFullscreenExpand)) {
    styleParams.allowFullscreenExpand = flatStyles.allowFullscreenExpand;
  }

  if (!_lodash2.default.isUndefined(flatStyles.itemClick)) {
    styleParams.openStraightInFullscreen = flatStyles.itemClick === 3;
  }

  styleParams.sharpParams = {
    quality: 90,
    usm: {}
  };

  if (!_lodash2.default.isUndefined(flatStyles.usmToggle) && flatStyles.usmToggle === true) {
    styleParams.sharpParams.allowUsm = flatStyles.usmToggle;

    if (!_lodash2.default.isUndefined(flatStyles.imageQuality)) {
      styleParams.sharpParams.quality = flatStyles.imageQuality;
    }
    if (!_lodash2.default.isUndefined(flatStyles.usm_a)) {
      styleParams.sharpParams.usm.usm_a = (flatStyles.usm_a || 0) / 100;
    }
    if (!_lodash2.default.isUndefined(flatStyles.usm_r)) {
      styleParams.sharpParams.usm.usm_r = flatStyles.usm_r;
    }
    if (!_lodash2.default.isUndefined(flatStyles.usm_t)) {
      styleParams.sharpParams.usm.usm_t = (flatStyles.usm_t || 0) / 255;
    }
  }

  return styleParams;
};

function convertToMobileSettingIfNeeded(styles) {
  (0, _keys2.default)(styles).forEach(function (val) {
    if (val.startsWith('m_')) {
      styles[val.slice(2)] = styles[val];
    }
  });
  return styles;
}